import { render } from "./PreloaderData.vue?vue&type=template&id=a153131a&scoped=true"
import script from "./PreloaderData.vue?vue&type=script&lang=js"
export * from "./PreloaderData.vue?vue&type=script&lang=js"

import "./PreloaderData.vue?vue&type=style&index=0&id=a153131a&scoped=true&lang=css"

import exportComponent from "/var/srv/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a153131a"]])

export default __exports__